import { useTranslation } from "@opendash/i18n";
import { Empty } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useProjectFilter } from "../hooks/useProjectFilter";
import { ProjectGrid } from "./ProjectGrid";

type Props = {};

export const ProjectsOverview = observer((props: Props) => {
  const t = useTranslation();
  const { areFiltersEmpty, filteredProjects, rootProjects, allProjects } =
    useProjectFilter();

  return (
    <>
      {(!allProjects || allProjects.length === 0) && (
        <Empty description={t("maintenance:project.empty")} />
      )}

      {!areFiltersEmpty && (
        <ProjectGrid
          hideSubProjects
          projects={filteredProjects}
          title={t("maintenance:project.filtered")}
          emptyMessage={t("maintenance:project.filter.noResults")}
        />
      )}

      {rootProjects.length !== 0 && (
        <ProjectGrid
          projects={rootProjects}
          title={t("maintenance:project.root")}
        />
      )}

      {allProjects.length !== 0 && (
        <ProjectGrid
          hideSubProjects
          projects={allProjects}
          title={t("maintenance:project.assigned")}
        />
      )}
    </>
  );
});
